// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

	// Bind Event for input search Mobile
	var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
	InstantSearchMobile.prototype.bindEvents = function() {
	  bindEventsMobile.call(this);
	  var searchButtonMobile = '#boost-pfs-search-box-1';
	  $(searchButtonMobile).prop("disabled", false); // Element(s) are now enabled.


	}
})();